import { forwardRef } from 'react';

import { cn } from '../../lib/utils';

export const TextEyebrow = forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
  ({ className, ...props }, ref) => (
    <span
      ref={ref}
      className={cn('text-steel-300 m-0 font-sans text-sm font-semibold tracking-wide uppercase', className)}
      {...props}
    />
  ),
);
TextEyebrow.displayName = 'TextEyebrow';
